import React from 'react'
import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/miranda-react'

import { type ManagedBy } from 'core/domain/ManagedBy'
import { Logo } from 'core/ui/components/logo/Logo'

import { type Shipper } from '../domain/Shipper'
import { formatContact } from '../presenter/shipperHeaderPresenter'

export type ShipperHeaderProps = {
  shipper: Shipper
  managedBy?: ManagedBy
}

const StyledText = styled(Text)`
  :after {
    content: ' • ';
  }

  :last-child:after {
    content: none;
  }
`

export function ShipperHeader({ shipper, managedBy }: ShipperHeaderProps): React.JSX.Element {
  const contact = formatContact(shipper, managedBy)

  return (
    <Layout.Group gap="spacing-4" align="center">
      <Logo url={shipper.logoUrl} />
      <Layout.Stack gap="spacing-1">
        <Text>Shipper</Text>
        <Text variant="body-md-bold">{shipper.companyName}</Text>
        <Layout.Group gap="spacing-1">
          {contact.name && <StyledText>{contact.name}</StyledText>}
          {contact.email && <StyledText>{contact.email}</StyledText>}
          {contact.phone && <StyledText>{contact.phone}</StyledText>}
        </Layout.Group>
      </Layout.Stack>
    </Layout.Group>
  )
}
